import React, { useState } from 'react'
import { Box, Card, Typography, Divider } from '@mui/material'
import { mainGreen, mainPurple, mainRed } from '../../utils/color'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'

const getStatusColor = (status) => {
	if (status === 'transfer') return mainPurple
	if (status === 'delete') return mainRed
	return mainGreen
}

const getStatusText = (status, detail) => {
	switch (status) {
		case 'transfer':
			return 'chuyển đến'
		case 'create':
			return 'chờ xử lý'
		case 'pending-produce':
			return 'chờ xác nhận xử lý'
		case 'pending-delete-produce':
		case 'pending-delete-ship':
		case 'pending-delete-success':
			return 'chờ hủy đơn'
		case 'confirm-delete-produce':
		case 'confirm-delete-ship':
		case 'confirm-delete-success':
			return 'đã hủy'
		case 'produce':
			return !detail?.producer?.produceEnd ? 'đang xử lý' : 'đã xử lý'
		case 'ship':
			return !detail?.shipper?.produceEnd ? 'đang giao' : ''
		case 'success':
			return 'giao thành công'
		default:
			return ''
	}
}

export default function StatisticsOrderDetail({ order, onViewDetail, onViewHistory, onImageClick, token }) {
	const [isExpanded, setIsExpanded] = useState(false)
	const [vatLoading, setVatLoading] = useState(false)
	const [vatExported, setVatExported] = useState(false)
	// Xử lý dữ liệu đơn hàng đã xóa
	const orderData = order?.order?.deletor ? { detail: order.order.orderData, deletor: order.order.deletor } : order
	const isVatExported = vatExported || !!orderData?.detail?.vatExport?.exported

	const renderStatusBadge = () => {
		return (
			<>
				{orderData?.detail?.status ? (
					<Typography sx={styles.statusBadge(getStatusColor(orderData?.detail?.status))}>
						{orderData?.detail?.shiftCode}
						{orderData?.detail?.shiftIndex} - {getStatusText(orderData?.detail?.status, orderData?.detail)}
					</Typography>
				) : null}
				{orderData?.deletor && (
					<Typography sx={styles.statusBadge(mainRed)}>
						<b>Người xóa: </b>
						{orderData?.deletor?.name}
					</Typography>
				)}
				{orderData?.detail?.edited?.value && (
					<Typography
						sx={styles.historyLink}
						onClick={(e) => {
							e.stopPropagation()
							onViewHistory(orderData)
						}}>
						Lịch sử
					</Typography>
				)}
			</>
		)
	}

	const renderOrderInfo = (label, value) => (
		<Typography sx={styles.infoText} whiteSpace='pre-line'>
			<b>{`${label}: `}</b>
			{value}
		</Typography>
	)

	return (
		<Card sx={styles.card}>
			<Box display='flex' flexDirection='column'>
				<Box display='flex' alignItems='center' justifyContent='space-between'>
					{renderStatusBadge()}
				</Box>


				{renderOrderInfo('Khối lượng', `${orderData?.detail?.quantity}kg`)}
				{renderOrderInfo('Tiền', `${orderData?.detail?.totalPrice?.toLocaleString()}đ`)}
				{renderOrderInfo('Thông tin', orderData?.detail?.detail)}
				{renderOrderInfo(
					'Mặt hàng',
					orderData?.detail?.line_items?.map((item) => `${item.quantity}x${item.name}`).join(', '),
				)}
				{renderOrderInfo('Phí giao hàng', `${orderData?.detail?.shippingTotal?.toLocaleString()}đ`)}
				{renderOrderInfo('Thông tin khách hàng', orderData?.detail?.customerNote)}
				{renderOrderInfo('Thời gian giao hàng', orderData?.detail?.shippingTime)}
				{renderOrderInfo('Ghi chú', orderData?.detail?.note?.replaceAll('\n\n', '\n').replaceAll('\n', ', '))}

				{orderData?.detail?.ahamove && <Typography sx={styles.ahamoveBadge}>Đã đặt Ahamove</Typography>}

				{isExpanded && (
					<>
						<Divider sx={styles.divider} />
						{renderOrderInfo('Người tạo', orderData?.detail?.creator?.user?.name)}
						{renderOrderInfo('Thời gian tạo', orderData?.detail?.creator?.createdAt)}

						<Divider sx={styles.divider} />
						{/* Producer info */}
						{renderOrderInfo(
							'Người xử lý',
							orderData?.detail?.producer?.user?.name ||
								orderData?.detail?.toStoreOrder?.producer?.user?.name ||
								'Chưa có',
						)}
						{renderOrderInfo(
							'Nhận xử lý',
							(orderData?.detail?.producer?.produceStart ?? 'Chưa có') ||
								(orderData?.detail?.toStoreOrder?.producer?.produceStart ?? 'Chưa có'),
						)}
						{renderOrderInfo(
							'Hoàn thành xử lý',
							orderData?.detail?.producer?.produceEnd ||
								orderData?.detail?.toStoreOrder?.producer?.produceEnd ||
								'Chưa có',
						)}

						<Divider sx={styles.divider} />
						{/* Shipper info */}
						{renderOrderInfo(
							'Người giao hàng',
							orderData?.detail?.shipper?.user?.name ||
								orderData?.detail?.toStoreOrder?.shipper?.user?.name ||
								'Chưa có',
						)}
						{renderOrderInfo(
							'Nhận giao hàng',
							orderData?.detail?.shipper?.shipStart || orderData?.detail?.toStoreOrder?.shipper?.shipStart || 'Chưa có',
						)}
						{/* {renderOrderInfo(
							'Người xác nhận giao hàng',
							orderData?.detail?.confirmShip?.user?.name ||
								orderData?.detail?.toStoreOrder?.confirmShip?.user?.name ||
								'Chưa có',
						)} */}
						{renderOrderInfo(
							'Hoàn thành giao hàng',
							orderData?.detail?.shipper?.shipEnd || orderData?.detail?.toStoreOrder?.shipper?.shipEnd || 'Chưa có',
						)}
					</>
				)}

				<Divider sx={styles.divider} />

				{renderOrderInfo('Code', orderData?.detail?.code)}
				{renderOrderInfo('Nền tảng', orderData?.detail?.source)}

				<Box display='flex' justifyContent='center'gap={2}>
					<Typography
						sx={styles.expandButton}
						onClick={() => {
							setIsExpanded(!isExpanded)
							if (!isExpanded) {
								onViewDetail(orderData)
							}
						}}>
						{isExpanded ? 'Thu gọn' : 'Chi tiết'}
					</Typography>
					
					{orderData?.detail?.status === 'success' &&
						(isVatExported ? (
							<Typography sx={{ ...styles.expandButton, color: mainGreen, pointerEvents: 'none' }}>
								Đã xuất hóa đơn
							</Typography>
						) : (
							<Typography
								sx={{
									...styles.expandButton,
									color: vatLoading ? '#999' : '#1939B7',
									pointerEvents: vatLoading ? 'none' : 'auto',
								}}
								onClick={async () => {
									if (vatLoading) return
									setVatLoading(true)
									try {
										await axios({
											url: `${DOMAIN}/order/export-vat`,
											method: 'POST',
											headers: { Authorization: `Bearer ${token}` },
											data: { orderId: orderData?.detail?._id },
											withCredentials: true,
										})
										setVatExported(true)
										alert('Xuất VAT thành công!')
									} catch (err) {
										alert(err?.response?.data?.message || 'Lỗi xuất VAT')
									} finally {
										setVatLoading(false)
									}
								}}>
								{vatLoading ? 'Đang xuất...' : 'Xuất VAT'}
							</Typography>
						))}
				</Box>
			</Box>

			<Box sx={{ p: 0 }}>
				{orderData?.detail?.tag?.map((tag, index) => (
					<Typography key={index} sx={styles.tag(tag.color)}>
						{tag.name}
					</Typography>
				))}

				<Box>
					{orderData?.detail?.photoAttach?.map((photo, index) => (
						<img
							key={index}
							loading='lazy'
							src={photo}
							onClick={() => onImageClick(photo)}
							style={styles.photoAttach}
							alt=''
						/>
					))}
				</Box>
			</Box>
		</Card>
	)
}

const styles = {
	card: {
		marginBottom: '10px',
		padding: '10px',
		textAlign: 'left',
		borderRadius: '16px',
		// width: '100%',
		maxWidth: '600px',
	},
	statusBadge: (color) => ({
		display: 'inline-flex',
		alignItems: 'center',
		padding: '0 10px',
		background: color,
		color: '#fff',
		borderRadius: '10px',
		mb: 1,
		width: 'fit-content',
	}),
	historyLink: {
		display: 'inline-flex',
		mb: 1,
		ml: 1,
		textDecoration: 'underline',
		color: '#1939B7',
		cursor: 'pointer',
		fontStyle: 'italic',
	},
	infoText: {
		fontSize: '15px',
		alignItems: 'center',
	},
	ahamoveBadge: {
		display: 'inline-flex',
		padding: '5px 10px',
		background: '#f4511e',
		color: '#fff',
		borderRadius: '10px',
		fontSize: '14px',
		width: 'fit-content',
	},
	divider: {
		my: 1,
	},
	expandButton: {
		display: 'inline-flex',
		textDecoration: 'underline',
		color: '#1939B7',
		cursor: 'pointer',
		fontStyle: 'italic',
		fontSize: '14px',
	},
	tag: (color) => ({
		display: 'inline-block',
		fontSize: '12px',
		padding: '2px 10px',
		borderRadius: '10px',
		color: '#fff',
		background: color,
		mr: 1,
	}),
	photoAttach: {
		maxWidth: '100px',
		maxHeight: '100px',
		marginRight: '8px',
		marginTop: '5px',
		cursor: 'pointer',
	},
}
